import { css } from 'lit';

export const rangeInputStyles = css`
  input[type='range'] {
    width: 100%;
    margin: 6px 0;
    background-color: transparent;
    -webkit-appearance: none;
  }
  input[type='range']:focus {
    outline: none;
  }
  input[type='range']::-webkit-slider-runnable-track {
    background: white;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 6px;
    width: 100%;
    height: 12px;
    cursor: pointer;
  }
  input[type='range']::-webkit-slider-thumb {
    margin-top: -8px;
    width: 24px;
    height: 24px;
    background: #ffffff;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 12px;
    cursor: pointer;
    -webkit-appearance: none;
  }
  input[type='range']:focus::-webkit-slider-runnable-track {
    background: white;
  }
  input[type='range']::-moz-range-track {
    background: white;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 6px;
    width: 100%;
    height: 12px;
    cursor: pointer;
  }
  input[type='range']::-moz-range-thumb {
    width: 24px;
    height: 24px;
    background: #ffffff;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 12px;
    cursor: pointer;
  }
  input[type='range']::-ms-track {
    background: transparent;
    border-color: transparent;
    border-width: 6px 0;
    color: transparent;
    width: 100%;
    height: 12px;
    cursor: pointer;
  }
  input[type='range']::-ms-fill-lower {
    background: white;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 12px;
  }
  input[type='range']::-ms-fill-upper {
    background: white;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 12px;
  }
  input[type='range']::-ms-thumb {
    width: 24px;
    height: 24px;
    background: #ffffff;
    border: 2px solid var(--screen-slide-control-line-color);
    border-radius: 12px;
    cursor: pointer;
    margin-top: 0px;
    /*Needed to keep the Edge thumb centred*/
  }
  input[type='range']:focus::-ms-fill-lower {
    background: hsla(0, 0%, 100%, 0.5);
  }
  input[type='range']:focus::-ms-fill-upper {
    background: hsla(0, 0%, 100%, 0.5);
  }
`;
